export default "__VITE_PUBLIC_ASSET__4c49c240__"